export enum DlcoAnalysisSetTypeEnum {
	Overread = "DAS_OVERREAD",
	QC = "DAS_QC",
	Site = "DAS_SITE",
}